import z from 'zod'

export const FeedbackCreateRequestSchema = z.object({
  text: z.string().min(1).max(5000),
  email: z.string().email().optional(),
  url: z.string().optional(),
})

export const FeedbackResponseSchema = z.object({
  id: z.string(),
})

export const FeedbackSlackMetaSchema = z.object({
  channel: z.string(),
  ts: z.string(),
  thread_ts: z.string().optional(),
})

export type FeedbackCreateRequest = z.infer<typeof FeedbackCreateRequestSchema>
export type FeedbackResponse = z.infer<typeof FeedbackResponseSchema>
export type FeedbackSlackMeta = z.infer<typeof FeedbackSlackMetaSchema>
